export const HOME = {
  emergentLink: 'emergent-link',
  heroSection: 'home-hero-section',
  heroTitle: 'home-hero-title',
  heroCtaBtn: 'home-hero-cta-btn',
  servicesSection: 'home-services-section',
  industriesSection: 'home-industries-section',
  ctaBand: 'home-cta-band',
  contactBtn: 'home-contact-btn',
};

export const NAV = {
  logo: 'nav-logo',
  servicesMenu: 'nav-services-menu',
  industriesMenu: 'nav-industries-menu',
  aboutLink: 'nav-about-link',
  insightsLink: 'nav-insights-link',
  contactLink: 'nav-contact-link',
  ctaBtn: 'nav-cta-btn',
  mobileMenuBtn: 'nav-mobile-menu-btn',
  mobileMenu: 'nav-mobile-menu',
};

export const CONTACT = {
  form: 'contact-form',
  nameInput: 'contact-name-input',
  emailInput: 'contact-email-input',
  phoneInput: 'contact-phone-input',
  companyInput: 'contact-company-input',
  serviceSelect: 'contact-service-select',
  messageInput: 'contact-message-input',
  submitBtn: 'contact-submit-btn',
  successMsg: 'contact-success-msg',
  errorMsg: 'contact-error-msg',
};

export const ADMIN = {
  loginForm: 'admin-login-form',
  loginEmail: 'admin-login-email',
  loginPassword: 'admin-login-password',
  loginSubmit: 'admin-login-submit',
  dashboard: 'admin-dashboard',
  sidebar: 'admin-sidebar',
  logoutBtn: 'admin-logout-btn',
  blogList: 'admin-blog-list',
  blogNewBtn: 'admin-blog-new-btn',
  casesList: 'admin-cases-list',
  casesNewBtn: 'admin-cases-new-btn',
  inquiriesList: 'admin-inquiries-list',
};
